export interface CVSection {
  title: string;
  items: Array<{
    title: string;
    institution?: string;
    location?: string;
    date?: string;
    description?: string;
    details?: string[];
  }>;
  timeline?: Array<{
    label: string;
    period: string;
  }>;
}


const cvData: CVSection[] = [
  {
    title: 'Contact',
    items: [
      {
        title: 'Daphna Keidar',
        description: 'Senior AI/ML Engineer · Data Scientist · Software Engineer',
        details: [
          '(+41) 762044760',
          'daphkeidar@gmail.com',
          'alacrity.me|https://alacrity.me',
          'Google Scholar|https://scholar.google.com/citations?user=R27JOScAAAAJ&hl=en&oi=ao',
          'LinkedIn|https://www.linkedin.com/in/daphnakeidar/',
          'Citizenship: Germany, Israel',
          'Zurich, Switzerland',
          'C EU/EFTA permit'
        ]
      }
    ]
  },
  {
    title: 'Education',
    items: [
      {
        title: 'MSc. in Data Science (CS Department)',
        institution: 'ETH Zurich',
        location: 'Zurich, Switzerland',
        date: '2019–2022',
        description: ' '
        // description: 'Thesis: Causal representation learning on fMRI experiments at Prof. Schölkopf’s lab'
      },
      {
        title: 'BSc. in Math and Cognitive Neuroscience',
        institution: 'Hebrew University of Jerusalem',
        location: 'Jerusalem, Israel',
        date: '2015–2018',
        description: ' '

        // description: 'Magna cum Laude\nAmirim Honors Program (Scholarship). Thesis: Markov Chain Monte Carlo algorithm for random generation of graph 1‑factorisations with Prof. Linial'
      }
    ],
    timeline: [
      { label: 'ETH Zurich', period: '2019–2022' },
      { label: 'Hebrew University', period: '2015–2018' }
    ]
  },
  {
    title: 'Skills',
    items: [
      { title: 'Languages', description: 'English (C1), Hebrew (native), German (C1), Spanish (B1)' },
      { title: 'Programming', description: 'Python, C/C++, R, SQL, Typescript, React' },
      { title: 'Cloud & DB', description: 'Azure, PostgreSQL, Docker, Kubernetes, Neo4j, REST API, FastAPI' },
      { title: 'AI Tech & Tools', description: 'LLMs, RAG, Knowledge Graphs, GNN, sAI agents, CrewAI, OpenAI, LangChain, Transformers, PyTorch, TensorFlow, scikit‑learn' },
      { title: 'AI Research', description: '5 publications (4 co‑first author), 2 workshop papers, 150+ citations, h‑index 5' }
    ]
  },
  {
    title: 'Work Experience - Industry',
    items: [
      {
        title: 'Data Scientist',
        institution: 'Swarovski',
        location: 'Switzerland',
        date: '01/2026–present',
        details: []
      },
      {
        title: 'Data Scientist → AI Engineering Lead',
        institution: 'Keyoniq Technologies AG',
        location: 'Baar, Switzerland',
        date: '09/2023–10/2025',
        details: []

        // details: [
        //   'Built an AI‑powered clinical recommendation system for longevity from scratch, leading it to an MVP.',
        //   'Developed AI pipelines that use LLMs to ingest and process 1.2 million scientific papers into a structured medical knowledge base. Contributing to the full software life cycle, incl. evaluation and deployment.',
        //   'Created quick prototypes: an AI agentic recommendation system using RAG and an AI agentic longevity chatbot.',
        //   'Led a team of 4 developers: technical mentorship, planned the technical roadmap, led the system architecture design.',
        //   'Cross‑functional: collaborated closely with the business team and physicians to define product requirements',
        //   'Tech Stack: Python, SQL, LLMs, AI agents, RAG, KG, pandas, Docker, FastAPI, Azure DevOps, TypeScript, Microsoft Azure.'
        // ]
      },
      {
        title: 'Software Engineer',
        institution: 'AI Medical',
        location: 'Zurich, Switzerland',
        date: '04/2023–07/2023',
        details: []

        // details: [
        //   'Fine‑tuned and evaluated a CNN for brain anatomy segmentation to detect MS lesions in MRI images (DICOM). Python, PyTorch.',
        //   'Ensured regulatory compliance and prepared a submission to the FDA for medical device certification. Statistical analysis.'
        // ]
      },
      {
        title: 'Algorithm Developer and Software Engineer',
        institution: 'MobilEye (Intel subsidiary)',
        location: 'Jerusalem, Israel',
        date: '05/2018–08/2019',
        details: []

        // details: [
        //   'Implemented custom ML algorithms for road map generation from videos, which contributed to mapping all of the highways in Japan.',
        //   'Created efficient real‑time models for object segmentation and clustering of a 3D LiDAR point cloud.',
        //   'Tech Stack: C++, Python, scikit‑learn, pandas, clustering'
        // ]
      }
    ],
    timeline: [
      { label: 'Swarovski', period: '01/2026–present' },
      { label: 'Keyoniq Technologies AG', period: '09/2023–10/2025' },
      { label: 'AI Medical', period: '04/2023–07/2023' },
      { label: 'MobilEye', period: '05/2018–08/2019' }

    ]
  },
  {
    title: 'Work Experience - Academia',
    items: [
      {
        title: 'Machine Learning Scientist',
        institution: 'Weizmann Institute',
        location: 'Remote (Rehovot, Israel)',
        date: '04/2020–04/2021',
        details: []

        // details: [
        //   'Trained an ensemble of deep learning models for COVID‑19 detection in X‑ray images, generated data augmentations to increase the sparse medical dataset. The work resulted in two publications, for which I led the writing and am co‑first author.',
        //   'Tech stack: Python, PyTorch, CNNs, TensorBoard, Data augmentation, content‑based image retrieval.'
        // ]
      },
      {
        title: 'Data Scientist',
        institution: 'Predictive Medicine Group at Harvard',
        location: 'Ramat Gan, Israel',
        date: '02/2019–09/2019',
        details: []

        // details: [
        //   'Trained ML models for predicting diabetes risk, to examine the predictive power of family medical history, in collaboration with Israel’s largest healthcare provider. Data cleaning and transformation, feature selection, and ML model training on EHRs of 300K patients.',
        //   'Tech Stack: R, Python, SQL, Scikit‑Learn, statistical analysis, random forest, LSTM.'
        // ]
      },
      {
        title: 'Research Assistant',
        institution: 'Jeff Lichtman’s Lab at Harvard',
        location: 'Boston, USA',
        date: '07/2017–09/2017',
        details: []

        // details: [
        //   'Statistical analysis and interpretation of connective patterns in high resolution neural data. MATLAB, Python, monte carlo simulation.'
        // ]
      }
    ],
    timeline: [
      { label: 'Weizmann Institute', period: '04/2020–04/2021' },
      { label: 'Harvard PMG', period: '02/2019–09/2019' },
      { label: 'Harvard Lichtman Lab', period: '07/2017–09/2017' }
    ]
  },
  {
    title: 'Teaching',
    items: [
      {
        title: 'Teaching Assistant in Interactive Machine Learning, Visualization and Explainability',
        institution: 'ETH Zurich',
        location: 'Zurich, Switzerland',
        date: 'Spring 2022',
        description: ' '

        // description: 'Creating visualisations with React, TypeScript, and containerizing them with Docker.'
      },
      {
        title: 'Head Teaching Assistant ("Tzar") in Introduction to Machine Learning',
        institution: 'Hebrew University of Jerusalem',
        location: 'Jerusalem, Israel',
        date: 'Spring 2019',
        description: ' '
      }
    ],
    timeline: [
      { label: 'ETH Zurich', period: 'Spring 2022' },
      { label: 'Hebrew University', period: 'Spring 2019' }
    ]
  },
  {
    title: 'Publications',
    items: [
      {
        title: 'Conference and Journal',
        details: [
          'Keidar D*, Opedal A*, Jin Z, Sachan M. 2022, cited 32 times, acceptance rate: 25.4%. “Slangvolution: A Causal Analysis of Semantic Change and Frequency Dynamics in Slang”. ACL,',
          'Keidar D*, Zhong M*, Zhang C, Shrestha R. Y, Paudel B. “Towards Automatic Bias Detection in Knowledge Graphs”. short paper, 2021, cited 12 times, acceptance rate: 29.1%. EMNLP Findings',
          'Keidar D*, Yaron D*, et al. “COVID‑19 Classification of X‑ray Images Using Deep Neural Networks”. European Radiology, 2021, cited 83 times, impact factor 7.034.',
          'Yaron D*, Keidar D*, et al. “Point of Care Image Analysis for COVID‑19”. ICASSP, 2021, cited 11 times.',
          'Barak‑Corren Y, Tsurel D, Keidar D, I Gofer, Shahaf D, Leventer‑Roberts M, Barda N, Reis B Y. “The value of parental medical records for the prediction of diabetes and cardiovascular disease: a novel method for generating and incorporating family histories”. Journal of the American Medical Informatics Association 30 (12), 1915‑1924, 2023.',
          '*Equal contribution'
        ]
      },
      {
        title: 'Workshops',
        details: [
          'Rares C, Dück M, Alexandrov A, Matoševic P, Keidar D, El‑Assady M. “How Do Algorithmic Fairness Metrics Align with Human Judgement? A Mixed‑Initiative System for Contextualized Fairness Assessment.”. TREX 2022 in IEEE VIS., 2022, cited 4 times.',
          'Guzman C*, Keidar D*, et al. “Recovering Barabási‑Albert Parameters through Disentanglement.”. ICLR 2021 Workshop on Geometrical and Topological Representation Learning., 2021.'
        ]
      }
    ]
  }
];

export default cvData;
